import React from "react";
import { useNavigate } from "react-router";
import classes from "./latestNews.module.css";
import Title from "../../containers/title/title";
import Card from "../../containers/card/card";

const LatestNews = (props) => {
    const navigate = useNavigate();
    return (
        <div className={classes.Container}>
            <Title title={props.latestNewsTitle}/>
            <div className={classes.Card}>{props.latestNews?.map((item,i) => 
                (<Card key={i} item={item} click={() => window.location.href = item?.button_link} button={item.button_text}/>)
            )}</div>
        </div>
    )
}

export default LatestNews;